// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b09b2641","239":"df436190","453":"8aec08c3","732":"25f3e0d5"}[chunkId] + ".chunk.js";
};